import 'owl.carousel';

export default {
  init() {

  },
  finalize() {

      /* eslint-disable */
      $('.nav__btn').click(function(e) {
          e.preventDefault();
          $('body').toggleClass('nav__active');
          $(this).toggleClass('active');

          if( $(this).hasClass('active') ) {
              $(this).html('Close');
          } else {
              $(this).html('Menu');
          }

      });

      $('.testimonials__slider').owlCarousel({
          items: 1,
          loop: true,
          touchDrag: true,
          dots: true,
          margin:10,
          center: true,
          stagePadding: 20,
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayHoverPause: true,
          responsive : {
              992 : {
                  items: 2,
              }
          }
      });

          /* eslint-enable */



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js